/*eslint @typescript-eslint/no-empty-function: "off"*/

// must go before plugins
import {
  CompanyPDPState,
  Participant,
  PDPClass,
  Term,
} from '../../../../store/pdp/types';
import { ITags } from '../../../../store/providers/providerTypes';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { appDispatch, RootState } from '../../../../store/store';
import { useEffect, useRef, useState } from 'react';
import {
  getMyClasses,
  getMyManagingClasses,
  queryClasses,
  queryClassesFn,
} from '../../../../store/pdp/pdpSlice';
import {
  CompanyPDP,
  ICompany,
} from '../../../../store/companies/companiesTypes';
import cloneDeep from 'lodash/cloneDeep';
import messages from './Messages';
import { smartDateDuration } from '../../../../utils/date';
import { IUsers } from '../../../../store/users/usersType';
import moment from 'moment-jalaali';
import { navigate } from '@reach/router';
import {
  black,
  blue,
  lightBlue,
  lightGray,
  lightGreen,
} from '../../../../utils/style/colors';
import HoverIcon from '../../../../components/HoverIcon';
import {
  convertNumbersToProperFormat,
  isANumber,
} from '../../../../utils/number';
import ExportExcell, { ExcelDataProps } from './ExportExcell';
import DistrictAnalytics from './DistrictAnalytics';
import Popover from '../../../../components/Popover';
import { getAnalyse } from '../../../../store/survey/surveySlice';
import { IAnalyticsQuery } from '../../../../store/entity/IAnalyticsQuery';
import { IAnalyticResponse } from '../../../../store/entity/IAnalyticResponse';

interface IOwnProps {
  term?: Term;
  pdpState: CompanyPDPState;
  company: ICompany;
  isPdpAdmin: boolean;
  thisUserId: number;
  tags: ITags['data'];
  selectedPdpPanel: CompanyPDP;
  year?: number | 'Others';
}

interface StateToProps {
  users: IUsers['map'];
}

interface DispatchToProps {
  queryClasses: (
    pdpId: number,
    startDate?: number,
    endDate?: number,
    isTemplate?: boolean,
    termId?: number,
    includeDeleted?: boolean
  ) => ReturnType<typeof queryClassesFn>;
  getAnalyse: (
    dataQuery: IAnalyticsQuery,
    surveyToken?: string,
    ownerToken?: string,
    reportToken?: string
  ) => Promise<{ result: IAnalyticResponse }>;
}

type IComponentProps = IOwnProps & StateToProps & DispatchToProps;

export const getMyClassInfo = (
  isPdpAdmin: boolean,
  clazz: PDPClass,
  thisUserId: number,
  startOfWeek: number,
  endOfWeek: number,
  startOfDay: number,
  endOfDay: number
) => {
  const myMembership = clazz.participants[thisUserId];
  let holdType = clazz.properties.holdType;
  const group = !isPdpAdmin
    ? clazz.properties.classGroups.length > 1
      ? (myMembership as Participant)?.participantProps?.group
      : clazz.properties.classGroups[0]?.key
    : null;
  let start = Number.MAX_VALUE;
  let end = 0;
  clazz.properties.phaseProps.forEach((p) => {
    if (myMembership) {
      const override = (
        myMembership as Participant
      )?.participantProps?.phasePropOverride?.find(
        (it) =>
          it.phaseTagId === p.phaseTagId && it.phaseStageId === p.phaseStageId
      );
      if (override) {
        start = Math.min(
          start,
          override.startDate ||
            p.phaseStartDates[myMembership.participantProps.group!] ||
            start
        );
        end = Math.max(
          end,
          override.endDate ||
            p.phaseEndDates[myMembership.participantProps.group!] ||
            end
        );
      }
    } else if (group) {
      start = Math.min(start, p.phaseStartDates[group!] || start);
      end = Math.max(end, p.phaseEndDates[group!] || end);
    } else {
      Object.values(p.phaseStartDates || {}).forEach((psd) => {
        start = Math.min(start, psd || start);
      });
      Object.values(p.phaseEndDates || {}).forEach((ped) => {
        end = Math.max(end, ped || end);
      });
    }
  });

  const duration =
    end !== 0 && start !== Number.MAX_VALUE
      ? smartDateDuration(start, end, true, true)
      : null;
  if (group)
    holdType =
      clazz.properties.classGroups.find((it) => it.key === group)?.holdType ||
      holdType;
  const inWeek = start > startOfWeek && start < endOfWeek;
  const inCurrentDay = start > startOfDay && start < endOfDay;
  return { holdType, group, duration, inWeek, inCurrentDay };
};
const ClassListView: React.FC<IComponentProps> = (props) => {
  const [effectiveTermIds, setEffectiveTermIds] = useState([] as number[]);
  const [classesFetched, setClassesFetched] = useState(new Set<number>());
  const [isAnalyticsOpen, setIsAnalyticsOpen] = useState(false);
  const [classGrades, setClassGrades] = useState(
    {} as { [classId: number]: { [phaseTagId: number]: number } }
  );
  const [phaseWithGrade, setPhaseWithGrade] = useState([] as number[]);
  const [loadingGrades, setLoadingGrades] = useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    if (props.term) {
      setEffectiveTermIds([props.term.id!]);
      return;
    }
    const terms = Object.values(props.pdpState?.terms || {}).filter(
      (it) =>
        it.term &&
        ((props.year === 'Others' && !it.term!.startDate) ||
          (it.term!.startDate &&
            Number(moment(it.term!.startDate).format('jYYYY')) === props.year))
    );
    setEffectiveTermIds(
      terms
        .map((it) => it.term?.id)
        .filter((it) => it !== undefined)
        .map((it) => it as number)
    );
    terms
      .filter((it) => !classesFetched.has(it.term?.id ?? -1))
      .forEach((it) => {
        if (it.term?.id) {
          const promise = props.isPdpAdmin
            ? props.queryClasses(
                props.selectedPdpPanel.id,
                undefined,
                undefined,
                false,
                it.term.id,
                false
              )
            : Promise.all([
                appDispatch(
                  getMyClasses({
                    pdpId: props.selectedPdpPanel.id,
                    termId: it.term.id,
                  })
                ),
                appDispatch(
                  getMyManagingClasses({
                    pdpId: props.selectedPdpPanel.id,
                    termId: it.term.id,
                  })
                ),
              ]);
          promise.then(() => {
            setClassesFetched((prevState) => {
              prevState.add(it.term!.id!);
              return cloneDeep(prevState);
            });
          });
        }
      });
  }, [props.year, props.term]);

  const toShowClasses = Object.values(props.pdpState?.classes || {})
    .filter((c) => {
      return c.relatedTermIds.find((r) => effectiveTermIds.includes(r));
    })
    .sort((a, b) => (a.startDate || 0) - (b.startDate || 0));
  const startOfWeek = moment().startOf('week').valueOf();
  const endOfWeek = moment().endOf('week').valueOf();
  const startOfDay = moment().startOf('day').valueOf();
  const endOfDay = moment().endOf('day').valueOf();
  const currentDay = useRef<HTMLElement | null>(null);
  let foundCurrentWeek = false;
  let foundCurrentDay = false;
  useEffect(() => {
    if (currentDay.current) {
      currentDay.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [props.year, props.term, props.pdpState?.classes]);

  const getTutor = (
    clazz: PDPClass,
    group: false | string | null | undefined
  ) => {
    const tutor =
      props.users[clazz.teacherUserId || 0]?.name ||
      clazz.properties.teacher ||
      '--';
    if (group)
      return (
        props.users[
          clazz.properties.classGroups.find((it) => it.key === group)
            ?.teacherUserId ||
            clazz.teacherUserId ||
            0
        ]?.name || tutor
      );
    else
      return (
        Array.from(
          new Set(
            clazz.properties.classGroups
              .map((it) => it.teacherUserId || clazz.teacherUserId)
              .filter((it) => !!it)
          )
        )
          .map((it) => props.users[it!]?.name)
          .join(messages.comma) ||
        clazz.properties.teacher ||
        '--'
      );
  };
  const fetchClassGrades = async () => {
    if (!props.isPdpAdmin || toShowClasses.length === 0) return;
    const pdpPanel = props.company.pdpPanels.find(
      (p) => p.id === props.selectedPdpPanel.id
    );
    if (!pdpPanel) return;
    setLoadingGrades(true);
    try {
      const classIds = toShowClasses.map((c) => c.id);
      const allPhaseProps = toShowClasses.flatMap((c) =>
        c.properties.phaseProps.filter((p) => !p.disabled)
      );
      const uniquePhaseTagIds = Array.from(
        new Set(allPhaseProps.map((p) => p.phaseTagId))
      );

      const dataQuery: IAnalyticsQuery = {
        filters: [],
        buckets: [
          {
            field: 'tags',
            type: 'bucket',
            name: 'classes',
            includeTotal: true,
            validBuckets: classIds.map((id) => -id),
            subBuckets: [
              {
                field: 'tags',
                type: 'bucket',
                validBuckets: uniquePhaseTagIds,
                name: 'phases',
              },
            ],
          },
        ],
        metrics: [
          { metric: 'percentageOfTotalAvg', field: 'score', name: 'score' },
        ],
      };

      const { result } = await props.getAnalyse(
        dataQuery,
        undefined,
        undefined,
        pdpPanel!.ownerReportToken!
      );

      const grades: { [classId: number]: { [phaseTagId: number]: number } } =
        {};
      const foundPhases = new Set<number>();

      const classes = result.categories?.['classes'];
      if (classes) {
        classes.buckets.forEach((classBucket: any) => {
          const classId = Math.abs(Number(classBucket.val));
          grades[classId] = {};

          classBucket.categories['phases'].buckets.forEach(
            (phaseBucket: any) => {
              const phaseTagId = Number(phaseBucket.val);
              const score = phaseBucket.metrics['score'];
              if (isANumber(score)) {
                grades[classId][phaseTagId] = score;
                foundPhases.add(phaseTagId);
              }
            }
          );
        });
      }

      const phasePropsWithGrade =
        pdpPanel?.properties.classPhaseDefaultProps
          ?.filter((p) => p.phaseWithGrade)
          .map((p) => p.phaseTagId) || [];

      const validPhases = Array.from(foundPhases)
        .filter((phaseId) => phasePropsWithGrade.includes(phaseId))
        .sort(
          (a, b) =>
            (props.tags[a]?.order || Number(props.tags[a]?.id)) -
            (props.tags[b]?.order || Number(props.tags[b]?.id))
        );

      setClassGrades(grades);
      setPhaseWithGrade(validPhases);
    } catch (error) {
      console.error('Failed to fetch class grades:', error);
    } finally {
      setLoadingGrades(false);
    }
  };

  const handleGetTableData = () => {
    const gradeHeaders = phaseWithGrade.reduce((acc, phaseId) => {
      const title = props.tags[phaseId]?.text || phaseId.toString();
      return { ...acc, [title]: title };
    }, {});

    const data: ExcelDataProps[] = [
      {
        title: messages.title,
        ...(props.isPdpAdmin && { targetGroup: messages.targetGroup }),
        duration: messages.period,
        tutor: messages.teacherName,
        holdIn: messages.holdType,
        trainingHour: messages.trainingHour,
        participantCount: messages.participant,
        approvedParticipants: messages.approved,
        ...gradeHeaders,
      },
    ];
    toShowClasses.map((clazz) => {
      const isPdpAdmin = props.isPdpAdmin;
      const thisUserId = props.thisUserId;
      const { holdType, group, duration } = getMyClassInfo(
        isPdpAdmin,
        clazz,
        thisUserId,
        startOfWeek,
        endOfWeek,
        startOfDay,
        endOfDay
      );

      // targetGroup
      let targetGroup = '';
      if (props.isPdpAdmin) {
        targetGroup = clazz.relatedTermIds.reduce((current, item) => {
          return (
            current +
            (current.length > 0 ? ', ' : '') +
            (props.pdpState.terms![item].term?.properties?.name ?? '')
          );
        }, '');
      }
      //
      const tutor = getTutor(clazz, group);

      const gradeData = phaseWithGrade.reduce((acc, phaseId) => {
        const title = props.tags[phaseId]?.text || phaseId.toString();
        const score = classGrades[clazz.id]?.[phaseId];
        return {
          ...acc,
          [title]: isANumber(score) ? Number(score.toFixed(0)) : '--',
        };
      }, {});

      data.push({
        title: `${props.pdpState.topics?.[clazz.topicId]?.properties?.name} ${
          clazz.properties.corrective ? ` (${messages.corrective})` : ''
        }`,
        ...(targetGroup && { targetGroup }),
        duration: `${duration || '--'}`,
        tutor: `${tutor}`,
        holdIn: `${holdType ? props.tags[holdType]?.text : '--'}`,
        trainingHour: clazz.properties.trainingHour,
        participantCount: Object.values(clazz.participants).filter(
          (it) => it.participantProps.status !== 'Dropped'
        ).length,
        approvedParticipants: Object.values(clazz.participants).filter(
          (it) => it.participantProps.status === 'Approved'
        ).length,
        ...gradeData,
      });
    });
    return data;
  };
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        padding: '1em',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h5>{messages.classes}</h5>
        <div className="flex gap-2 justify-center align-center flex-row-reverse">
          {props.isPdpAdmin && (
            <Popover
              overlay={
                <div>
                  <DistrictAnalytics
                    toShowClasses={toShowClasses}
                    company={props.company}
                    isOpen={isAnalyticsOpen}
                  />
                </div>
              }
              trigger={'click'}
              visible={isAnalyticsOpen}
              placement="bottomLeft"
              onVisibleChange={setIsAnalyticsOpen}
            >
              <div>
                <HoverIcon color={blue} type={'pie-chart'} />
              </div>
            </Popover>
          )}
          {props.isPdpAdmin && (
            <HoverIcon
              color={blue}
              type="bar-chart-2"
              title={messages.classGrades}
              loading={loadingGrades}
              onClick={fetchClassGrades}
            />
          )}
          <ExportExcell
            getData={handleGetTableData}
            exportFileName={
              props.term
                ? messages.calendarOutputTerm(props.term)
                : isANumber(props.year)
                  ? messages.calenderOutput(Number(props.year) || 0)
                  : messages.calenderOutputStr(props.year?.toString() || '')
            }
          />
        </div>
      </div>
      <div style={{ overflow: 'auto', width: '100%', flexGrow: 1 }}>
        <table className="highlightedTable">
          <thead style={{ position: 'sticky', top: 0, background: lightGray }}>
            <tr>
              <th>{messages.title}</th>
              {props.isPdpAdmin && (
                <th style={{ maxWidth: '200px' }}>{messages.targetGroup}</th>
              )}
              <th>{messages.period}</th>
              <th>{messages.trainingHour}</th>
              <th>{messages.teacherName}</th>
              <th>{messages.holdType}</th>
              {phaseWithGrade.map((phaseId) => (
                <th key={phaseId}>{props.tags[phaseId]?.text || phaseId}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {toShowClasses.map((clazz) => {
              const isPdpAdmin = props.isPdpAdmin;
              const thisUserId = props.thisUserId;
              const { holdType, group, duration, inWeek, inCurrentDay } =
                getMyClassInfo(
                  isPdpAdmin,
                  clazz,
                  thisUserId,
                  startOfWeek,
                  endOfWeek,
                  startOfDay,
                  endOfDay
                );
              return (
                <tr
                  ref={(e) => {
                    if (!foundCurrentDay && inCurrentDay) {
                      foundCurrentDay = true;
                      currentDay.current = e;
                    }
                    if (!foundCurrentDay && !foundCurrentWeek && inWeek) {
                      foundCurrentWeek = true;
                      currentDay.current = e;
                    }
                  }}
                  key={clazz.id}
                  style={{
                    background: inCurrentDay
                      ? lightBlue
                      : inWeek
                        ? lightGreen
                        : undefined,
                  }}
                >
                  <td>
                    <a
                      style={{ color: black, fontWeight: 500 }}
                      href={`/t/${props.company.id}/pdp/${props.selectedPdpPanel.id}/terms/${props.term?.id ?? clazz.relatedTermIds[0]}/class/${clazz.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(e.currentTarget.href);
                      }}
                    >
                      {props.pdpState.topics?.[clazz.topicId]?.properties?.name}
                      {clazz.properties.corrective &&
                        ` (${messages.corrective})`}{' '}
                    </a>
                  </td>
                  {/* ------ */}
                  {isPdpAdmin && (
                    <td style={{ maxWidth: '200px' }}>
                      {clazz.relatedTermIds.reduce((current, item) => {
                        return (
                          current +
                          (current.length > 0 ? ', ' : '') +
                          props.pdpState.terms![item].term?.properties.name
                        );
                      }, '')}
                    </td>
                  )}
                  {/* ------ */}
                  <td>{duration || '--'}</td>
                  <td>
                    {(isANumber(clazz.properties.trainingHour) &&
                      convertNumbersToProperFormat(
                        clazz.properties.trainingHour!,
                        1
                      )) ||
                      '--'}
                  </td>
                  <th>{getTutor(clazz, group)}</th>
                  <th>{holdType ? props.tags[holdType]?.text : '--'}</th>
                  {phaseWithGrade.map((phaseId) => {
                    const score = classGrades[clazz.id]?.[phaseId];
                    return (
                      <th key={phaseId}>
                        {isANumber(score)
                          ? `${convertNumbersToProperFormat(score, 1)}%`
                          : '--'}
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps: MapStateToProps<StateToProps, IOwnProps, RootState> = (
  state,
  _ownProps
) => {
  const users = state.users.map;

  return { users };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => {
  return {
    queryClasses: (
      pdpId: number,
      startDate?: number,
      endDate?: number,
      isTemplate?: boolean,
      termId?: number,
      includeDeleted?: boolean
    ) =>
      appDispatch(
        queryClasses({
          pdpId,
          startDate,
          endDate,
          isTemplate,
          termId,
          includeDeleted,
        })
      ),
    getAnalyse: (
      dataQuery: IAnalyticsQuery,
      surveyToken?: string,
      ownerToken?: string,
      reportToken?: string
    ) =>
      appDispatch(
        getAnalyse({ dataQuery, surveyToken, ownerToken, reportToken })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassListView);
